module.exports = __webpack_public_path__ + "img/beian.94f6d2e5.png";